import {getVal, hideDialog, isnull, localGet, localGetBoolean, localSave, Toast, vibrate} from '../utils/tools'
import global from '../config/global'
import {loge, log} from '../utils/devext'
import IMHelper from './IMHelper'
import roomApi from '../api/room-api'
import aes from '../utils/aes'
import globalCfg from '../config/global'
import EventBusConstant from '../push/const/EventBusConstant'
import BlackUtils from '../utils/BlackUtils'
import BlockedUserUtils from '../utils/BlackUtils'
import Tips from "../utils/Tips";
import TipsUtils from "../utils/TipsUtils";

const {Event, Realtime, TextMessage, AudioMessage, TypedMessagesPlugin, ImageMessage, ConversationQuery, MessageQueryDirection, debug} = AV;
export const IMMessageType = {
  TEXT: TextMessage.TYPE,
  AUDIO: AudioMessage.TYPE,
  IMAGE: ImageMessage.TYPE,
}

export const MessageSendStatus = {
  SUCCESS: 0,   // 发送成功     对于对方的消息，默认未发送成功的状态
  SENDING: 1,  // 正在发送
  FAILED: 2    // 失败
}

export default class IMManager {
  static page = null
  static TAG = 'AVIM'
  static hasClientEvents = false
  static avimClient
  static curTargetDisplayAcc
  static curTargetPerson
  static curConvBase
  static messageIterator
  static createConvJob
  static isLoginServer
  static DELAY_QUERY_TIME = 50
  static queryJobs = new Map()

  static crtConvCallback;
  static blocked = false;

  static getRealtime(vueObj) {

    return new Promise((resolve, reject) => {
      if (vueObj.$root.realtime) {
        resolve(vueObj.$root.realtime)
      } else {
        new Promise((next, rej) => {
          AV.init({
            appId: aes.decrypt(globalCfg.im.app),
            appKey: aes.decrypt(globalCfg.im.key),
            // serverURL: globalCfg.im.server
          })
          vueObj.$root.realtime = new Realtime({
            appId: aes.decrypt(globalCfg.im.app),
            appKey: aes.decrypt(globalCfg.im.key),
            ssl: true,
            // 初始化即时通讯服务时需要指定富媒体消息插件
            plugins: [TypedMessagesPlugin],
          })
          next(vueObj.$root.realtime)
        }).then(realtime => {
          resolve(realtime)
        }).catch(error => {
          reject(new Error(' Realtime init failed'))
          console.log('realtime-error:' + error)
        })
      }
    })
  }

  static tryInitAVIMClient(vueObj) {
    this.page = vueObj
    if (global.debug) {
      localSave('debug', 'LC*')
      debug.enable()
    } else {
      debug.disable()
    }
    if (IMManager.isLoginServer) {
      return
    }
    return new Promise((resolve, reject) => {
      if (isnull(vueObj.$root.avimClient)) {
        if (!isnull(localGet(global.key.session, null)) && !isnull(global.getUserDisplay())) {
          this.getRealtime(vueObj).then(realtime => {
            realtime.createIMClient(global.getUser().displayAccountId).then(function (client) {
              IMManager.avimClient = client
              IMManager.isLoginServer = true
              IMManager.bindClientEvents(client)
              if (vueObj) {
                vueObj.$root.online = true
                vueObj.$root.avimClient = client
              }
              resolve(vueObj.$root.avimClient)
            }).catch(error => {
              IMManager.isLoginServer = false
            })
          }).catch(err => {
            reject(err)
          })
        } else {
          resolve(vueObj.$root.avimClient)
        }
      }
    }).catch(e => {
      console.log('init client exception' + e.message)
    })

  }

  static getClient(vueObj) {
    let page = this.wrapPage(vueObj)
    if (isnull(this.avimClient) && !isnull(page)) {
      this.avimClient = page.$root.avimClient
    }
    return this.avimClient
  }

  static wrapPage(vueObj) {
    return isnull(vueObj) ? this.page : vueObj
  }

  static exit(vueObj) {
    this.unbindClientEvents()
    if (this.getClient()) {
      this.avimClient.close()
    }
    this.avimClient = null
    let page = this.wrapPage(vueObj)
    if (!isnull(page)) {
      page.$root.avimClient = null
    }
    this.isLoginServer = false
    this.clearCreateJob()
  }

  static readAll(convs, successCallback, failCallback, retryCount = 0) {
    if (!isnull(this.getClient())) {
      let convIds = []
      convs.forEach(item => {
        convIds.push(item.conversationId)
      })
      this.getClient().getQuery().containedIn('objectId', convIds).find().then(conversations => {
        conversations.forEach(c => {
          if (c.unreadMessagesCount > 0) {
            c.read()
          }
        })
        convs.forEach(item => {
          item.unread = 0
        })
        successCallback && successCallback(convs)
      }).catch(error => {
        if (retryCount < 5) {
          IMManager.readAll(convs, successCallback, failCallback, ++retryCount)
        } else {
          failCallback && failCallback(error)
        }
      })
    } else {
      if (retryCount < 5) {
        IMManager.readAll(convs, successCallback, failCallback, ++retryCount)
      } else {
        failCallback && failCallback(new Error('Check your network'))
      }
    }
  }

  static read(roomConv, successCallback, failCallback, retryCount = 0) {

    if (!isnull(IMManager.getClient())) {
      this.getClient().getConversation(roomConv.conversationId).then(conv => {
        if (conv.unreadMessagesCount > 0) {
          conv.read()
        }
        roomConv.unread = 0
        successCallback && successCallback(roomConv)
      }).catch(err => {
        if (retryCount < 4) {
          return IMManager.read(roomConv, successCallback, failCallback, retryCount)
        } else {
          failCallback && failCallback(error)
        }
      })
    } else {
      if (retryCount < 4) {
        return IMManager.read(roomConv, successCallback, failCallback, retryCount)
      } else {
        failCallback && failCallback(error)
      }
    }

  }

  static bindClientEvents(client) {
    let parent = this
    if (client && !this.hasClientEvents) {
      this.hasClientEvents = true
      client.on(Event.MESSAGE, function messageEventHandler(message, conversation) {
        IMManager.checkAndCancelQueryJob(conversation)
        IMManager.onReceiveMessage(message, conversation)
      })
      client.on(Event.UNREAD_MESSAGES_COUNT_UPDATE, function (conversions) {
        if (isnull(conversions)) {
          return
        }
        var unreadCount = 0;
        conversions.forEach(item => {
          if (!isnull(item.lastMessage) && item.unreadMessagesCount > 0) {

            let parsedMessage = IMHelper.parseMessage(item.lastMessage)
            if (parsedMessage.awayAccountId > 0) {
              unreadCount += item.unreadMessagesCount
              try {
                IMManager.createQueryJob(item, item.unreadMessagesCount)
              } catch (e) {

              }
            }
          }
        })
        parent.page.$EventBus.$emit(EventBusConstant.EVENT_REFRESH_UNREAD_COUNT, unreadCount)
      })
    }

  }

  static unbindClientEvents() {
    let client = this.getClient()
    if (client && !this.hasClientEvents) {
      this.hasClientEvents = false
      client.off(Event.MESSAGE)
      client.off(Event.UNREAD_MESSAGES_COUNT_UPDATE)
    }

  }

  static quitConv(convId, vueObj, successCallback, failCallback) {
    this.internalLoadConvById(convId, vueObj, (conversation) => {
      if (conversation) {
        conversation.quit().then(conversation => {
          console.log('afterQuit:' + JSON.stringify(conversation))
          successCallback && successCallback(convId)
        }).catch(e => {
          console.table(e)
          failCallback && failCallback(convId)
        })
      }
    })
  }

  static blockUser(convId, awayId, successCallback, failCallback) {
    let conv = this.internalFetchConvById(convId, vueObj)
    if (conv != null) {
      conv.blockMembers([awayId]).then(PartiallySuccess => {
        console.log('afterBlock:' + JSON.stringify(PartiallySuccess))
        successCallback && successCallback(convId)
      }).catch(e => {
        failCallback && failCallback(convId)
      })
    }
  }

  static unblockUser(convId, awayId, successCallback, failCallback) {
    let conv = this.internalFetchConvById(convId, vueObj)
    if (conv != null) {
      conv.unblockMembers([awayId]).then(PartiallySuccess => {
        console.log('afterBlock:' + JSON.stringify(PartiallySuccess))
        successCallback && successCallback(convId)
      }).catch(e => {
        failCallback && failCallback(convId)
      })
    }
  }

  static bindConvEvents() {
    if (IMManager.curConvBase) {
      IMManager.curConvBase.on(Event.MESSAGE, function messageEventHandler(message) {
        // 请按自己需求改写
        var file
        switch (message.type) {
          case TextMessage.TYPE:
            console.log('收到文本消息，内容：' + message.getText() + '，ID：' + message.id)
            break
          case ImageMessage.TYPE:
            file = message.getFile()
            console.log('收到图像消息，URL：' + file.url() + '，宽度：' + file.metaData('width'))
            break
          case AudioMessage.TYPE:
            file = message.getFile()
            console.log('收到音频消息，URL：' + file.url() + '，长度：' + file.metaData('duration'))
            break
          case 1:
            console.log('OperationMessage 是自定义消息类型')
          default:
            // 未来可能添加新的自定义消息类型，新版 SDK 也可能添加新的消息类型。
            // 因此别忘了在默认分支中处理未知类型，例如提示用户升级客户端至最新版本。
            console.warn('收到未知类型消息')
        }
      })
    }
  }

  static createConvByP(person, vueObj, tryCount = 0) {
    this.curTargetPerson = person
    if (!isnull(this.curTargetPerson)) {
      this.createConv(this.curTargetPerson.displayAccountId, vueObj, tryCount)
    }
  }

  static fetchConvWithP(person, convId, vueObj, tryCount = 0) {
    this.curTargetPerson = person
    this.curTargetDisplayAcc = person.displayAccountId
    if (!isnull(this.curTargetPerson)) {
      this.fetchConvById(convId, vueObj, tryCount)
    }
  }

  static createConv(targetDisplayAcc, vueObj, tryCount = 0) {
    this.curTargetDisplayAcc = targetDisplayAcc
    if (!isnull(this.getClient())) {
      this.getClient().createConversation({
        members: [targetDisplayAcc],
        name: global.getUserDisplay() + '&' + targetDisplayAcc,
        transient: false,
        unique: true
      }).then(function (convBase) {
        IMManager.curConvBase = convBase
        convBase.read()
        IMManager.messageIterator = convBase.createMessagesIterator({
          limit: 20
        })
        IMManager.bindConvEvents()
        IMManager.clearCreateJob()
        IMManager.crtConvCallback && IMManager.crtConvCallback(0, 'Succeed to create conversation', vueObj)
      }).catch(e => {
        if (tryCount >= 3) {
          IMManager.crtConvCallback && IMManager.crtConvCallback(-2, 'Failed to create conversation with the host', vueObj)
        }
        IMManager.checkAnRecreateConv(vueObj, ++tryCount)
      })
    } else {
      IMManager.crtConvCallback && IMManager.crtConvCallback(-1, 'Failed to init chat info', vueObj)
    }
  }

  static fetchConvById(conversationId, vueObj, tryCount = 0) {
    if (!isnull(this.getClient())) {
      this.getClient(vueObj).getConversation(conversationId).then(conv => {
        IMManager.curConvBase = conv
        conv.read()
        IMManager.messageIterator = conv.createMessagesIterator({
          limit: conversationId == globalCfg.actPushConv ? 1 : 20
        })
        IMManager.bindConvEvents()
        IMManager.crtConvCallback && IMManager.crtConvCallback(0, 'Succeed to create conversation', vueObj)
      }).catch(e => {
        if (tryCount >= 3) {
          IMManager.crtConvCallback && IMManager.crtConvCallback(-2, 'Failed to create conversation with the host', vueObj)
          return
        }
        IMManager.fetchConvById(conversationId, vueObj, ++tryCount)
      })
    } else {
      if (tryCount >= 3) {
        IMManager.crtConvCallback && IMManager.crtConvCallback(-1, 'Failed to init chat info', vueObj)
      } else {
        this.tryInitAVIMClient(vueObj).then(() => {
          IMManager.fetchConvById(conversationId, vueObj, ++tryCount)
        }).catch(err => {
          IMManager.fetchConvById(conversationId, vueObj, ++tryCount)
        })
      }
    }
  }

  static internalLoadConvById(conversationId, vueObj, successCallBack, tryCount = 0) {
    if (!isnull(this.getClient())) {
      this.getClient(vueObj).getConversation(conversationId).then(conv => {
        successCallBack && successCallBack(conv)
      }).catch(e => {
        if (tryCount >= 3) {
          return
        }
        IMManager.internalFetchConvById(conversationId, vueObj, ++tryCount)
      })
    } else {
      if (tryCount < 3) {
        this.tryInitAVIMClient(vueObj).then(() => {
          IMManager.internalLoadConvById(conversationId, vueObj, successCallBack, ++tryCount)
        }).catch(err => {
          IMManager.internalLoadConvById(conversationId, vueObj, successCallBack, ++tryCount)
        })
      }
    }
  }

  static internalFetchConvById(conversationId, vueObj, tryCount = 0) {
    if (!isnull(this.getClient())) {
      this.getClient(vueObj).getConversation(conversationId).then(conv => {
        IMManager.crtConvCallback && IMManager.crtConvCallback(0, 'Succeed to create conversation', vueObj)
      }).catch(e => {
        if (tryCount >= 3) {
          IMManager.crtConvCallback && IMManager.crtConvCallback(-2, 'Failed to create conversation with the host', vueObj)
          return
        }
        IMManager.internalFetchConvById(conversationId, vueObj, ++tryCount)
      })
    } else {
      if (tryCount >= 3) {
        IMManager.crtConvCallback && IMManager.crtConvCallback(-1, 'Failed to init chat info', vueObj)
      } else {
        this.tryInitAVIMClient(vueObj).then(() => {
          IMManager.internalFetchConvById(conversationId, vueObj, ++tryCount)
        }).catch(err => {
          IMManager.internalFetchConvById(conversationId, vueObj, ++tryCount)
        })
      }
    }
  }

  static queryNormalConvs(vueObj, retry = false, retryCount = 0) {
    return new Promise((resolve, reject) => {
      if (!isnull(IMManager.getClient())) {
        IMManager.getClient().getQuery().containedIn('m', [global.getUserDisplay()]).exists('lm')
          .equalTo('unique', true).withLastMessagesRefreshed(true).compact(true)
          .descending('lm').limit(100).find().then(conversations => {
          if (vueObj) {
            vueObj.$root.online = true
          }
          let convs = []
          console.log(conversations)
          conversations.forEach((item) => {
            if (!isnull(item.lastMessage)) {
              let parsedMessage = IMHelper.parseMessage(item.lastMessage)
              if (parsedMessage.awayAccountId > 0) {
                item = IMHelper.instanceRoomConversation(item, parsedMessage)
                if (item.conversationType != 1) {
                  if (parsedMessage.from == global.getUserDisplay()) {
                    parsedMessage.sendStatus = MessageSendStatus.SUCCESS
                  }
                  parsedMessage.conversationId = item.conversationId
                  parsedMessage.unread = item.unreadCount
                  parsedMessage.convType = item.conversationType
                  convs.push(parsedMessage)
                }
              }
            }
          })
          resolve(convs, conversations)
        }).catch(err => {
          if (retry && retryCount < 4) {
            return IMManager.queryNormalConvs(vueObj, true, retryCount)
          }
          reject(err)
        })
      } else {
        if (retry && retryCount < 4) {
          return IMManager.queryNormalConvs(vueObj, true, retryCount)
        } else {
          reject(new Error('noData'))
        }
      }

    })
  }

  static queryServiceConvs(vueObj, retry = false, retryCount = 0) {
    return new Promise((resolve, reject) => {
      if (!isnull(IMManager.getClient())) {
        let actPushCfg = globalCfg.getActPushCfg()
        this.getClient(vueObj).getConversation(actPushCfg.conv).then(conv => {
          let convs = []
          conv.queryMessages({limit: 1, direction: MessageQueryDirection.NEW_TO_OLD}).then(messages => {
            messages.forEach(item => {
              let parsedMessage = IMHelper.parseMessage(item)
              if (!globalCfg.debug) {
                parsedMessage.awayAccountId = actPushCfg.acc
                parsedMessage.awayDisId = actPushCfg.dist
              }
              conv = IMHelper.instanceRoomConversation(conv, parsedMessage)
              if (parsedMessage.from == global.getUserDisplay())
                parsedMessage.sendStatus = MessageSendStatus.SUCCESS
              parsedMessage.conversationId = conv.conversationId
              parsedMessage.unread = conv.unreadCount
              parsedMessage.convType = conv.conversationType
              convs.push(parsedMessage)

            });
            resolve(convs)
          }).catch(err => {
            if (retry && retryCount < 4) {
              return IMManager.queryServiceConvs(vueObj, true, retryCount)
            } else {
              reject(err)
            }
          })

        }).catch(err => {
          if (retry && retryCount < 4) {
            return IMManager.queryServiceConvs(vueObj, true, retryCount)
          } else {
            reject(err)
          }
        })
      } else {
        if (retry && retryCount < 4) {
          return IMManager.queryServiceConvs(vueObj, true, retryCount)
        } else {
          reject(new Error('noData'))
        }
      }

    })
  }

  static queryConvs(successCallback, failCallback, vueObj, retry = false, retryCount = 0) {
    if (!isnull(this.getClient())) {
      Promise.all([this.queryNormalConvs(vueObj), this.queryServiceConvs(vueObj)]).then(datas => {
        let list = []
        for (let i = 0; i < datas.length; i++) {
          let tmp = datas[i]
          list.push(...tmp)
        }
        if (!isnull(list)) {
          list.sort((o1, o2) => {
            return o2.convType - o1.convType
          })
        }
        successCallback && successCallback(list, vueObj)
      }).catch(err => {
        failCallback && failCallback(err, vueObj)
      })
    } else {
      if (!retry || retryCount > 5) {
        IMManager.crtConvCallback && IMManager.crtConvCallback(-1, 'Failed to init chat info', vueObj)
      } else {
        this.tryInitAVIMClient(vueObj).then(() => {
          IMManager.queryConvs(successCallback, failCallback, vueObj, retry, ++retryCount)
        }).catch(err => {
          IMManager.queryConvs(successCallback, failCallback, vueObj, retry, ++retryCount)
        })
      }
    }
  }

  static checkAnRecreateConv(vueObj, tryCount = 0) {
    this.clearCreateJob()
    this.createConvJob = setTimeout(function () {
      if (!isnull(IMManager.curTargetPerson)) {
        IMManager.createConvByP(IMManager.curTargetPerson, vueObj, tryCount)
      } else if (!isnull(IMManager.curTargetDisplayAcc)) {
        IMManager.createConv(IMManager.curTargetDisplayAcc, vueObj, tryCount)
      }
    }, 500)
  }

  static clearCreateJob() {
    if (!isnull(this.createConvJob)) {
      clearTimeout(this.createConvJob)
      this.createConvJob = null
    }
  }

  static endConv() {
    this.clearCreateJob()
    // if (this.curConvBase)
    //   this.curConvBase.quit().then(() => {
    //
    //   }).catch(e => {
    //     loge(IMManager.TAG, 'end conversation failed:' + e.messages)
    //   })
    IMManager.curTargetDisplayAcc = '';
    IMManager.curTargetPerson = null;
    IMManager.curConvBase = null;
    IMManager.messageIterator = null;
    IMManager.blocked = false

  }

  static checkCanSend(vueObj) {
    if (BlockedUserUtils.hasBeenBlocked(IMManager.curTargetPerson.accountId) || this.blocked) {
      Toast.error(Tips.e_block_in_chat, this.page)
      return;
    }
    if (global.isSVip())
      return true
    if (!localGetBoolean(global.getUserDisplay() + '_show_chat_hint', false)) {
      vueObj.showChatTips = true
      return false
    }
    if (!global.checkCoinsEnough(2)) {
      Toast.error('Coins not enough', this.page)
      return false
    }
    return true
  }

  static sendMessage(message, isResend = false, statusCallBack = null) {
    if (!isResend) {
      let targetAcc = parseInt(getVal(IMManager.curTargetPerson, 'accountId', 0))
      roomApi.addChatConsume(targetAcc, (data, page) => {
        IMManager.blocked = data.blacklistStatus > 1
        global.setCoins(data.leftDiamond)
        IMManager._doSendMsgAction(message, isResend, statusCallBack)
      }, (code, msg, page) => {
        Toast.error(TipsUtils.getErrorTips(code), page)
        statusCallBack && statusCallBack(-3)
      }, IMManager.page)
    } else {
      IMManager._doSendMsgAction()
    }


  }

  static _doSendMsgAction(message, isResend = false, statusCallBack = null) {
    message.from = global.getUserDisplay()

    let attr = IMHelper.builderMessageAttr(this.curTargetPerson)

    switch (message.type) {
      case TextMessage.TYPE:
      case ImageMessage.TYPE:
        message.attributes = attr
        break
      case AudioMessage.TYPE:
        attr['duration'] = parseInt(Math.ceil(message.duration).toFixed(0))
        message.attributes = attr
        break
    }
    let parseMessage = IMHelper.parseMessage(message)
    let roomMessage = IMHelper.instanceRoomMessage(parseMessage)

    roomMessage.sendStatus = MessageSendStatus.SENDING

    this.refreshMessageUi(roomMessage)

    if (this.checkConvWithContent(message)) {
      this.curConvBase.send(message).then(msg => {
        IMManager.sendMsgSuc(roomMessage)
        statusCallBack && statusCallBack(0)
      }).catch(e => {
        if (!isnull(e.message) && e.message.indexOf('Timeout Exception') != -1) {
          statusCallBack && statusCallBack(0)
          IMManager.sendMsgSuc(roomMessage)
        } else {
          statusCallBack && statusCallBack(-1)
          IMManager.sendMsgFail(message, roomMessage)
        }
      })
    } else {
      statusCallBack && statusCallBack(-2)
      IMManager.sendMsgFail(message, roomMessage)
    }
  }

  static sendMsgFail(message, roomMessage) {
    message.timestamp = message.attributes['timestamp']
    roomMessage.sendStatus = MessageSendStatus.FAILED
    this.refreshMessageUi(roomMessage)

  }

  static sendMsgSuc(roomMessage) {
    roomMessage.sendStatus = MessageSendStatus.SUCCESS
    this.refreshMessageUi(roomMessage)
  }

  static sendTextMessage(text, isResend = false, statusCallback = null) {
    // text = BlackUtils.filterSensitiveLCMsg(text)
    this.sendMessage(new TextMessage(text), isResend, statusCallback)

  }

  static sendAudioMessage(path, isResend = false) {
    let file = new AV.File('voice', path)
    file.save().then(() => {
      let message = new AudioMessage(file)
      message.setText('[Voice]')
      return IMManager.sendMessage(message, isResend)
    }).then(() => {
    }).catch(error => {
      loge(IMManager.TAG, 'send Audio message failed:' + error.messages)
    })
  }

  static checkConvWithContent(src) {
    return this.curConvBase && !isnull(src)
  }

  static hasClient(page) {
    return !isnull(this.getClient(page))
  }

  static sendImageMessage(imageUrl, isResend = false) {
    let file = new AV.File(new Date().getTime() + '.jpg', {base64: imageUrl})
    file.save().then(() => {
      let message = new ImageMessage(file)
      message.setText('[Photo]')
      return IMManager.sendMessage(message, isResend)
    }).then(() => {
    }).catch(error => {
      loge(IMManager.TAG, 'send Image message failed:' + error)
    })
  }

  static sendImageMessageFile(file, width, height, isResend = false) {
    let avfile = new AV.File(new Date().getTime() + '.jpg', file)
    avfile.attributes.metaData.width = width
    avfile.attributes.metaData.height = height
    avfile.save().then(() => {
      hideDialog(IMManager.page)
      let message = new ImageMessage(avfile)
      message.setText('[Photo]')
      return IMManager.sendMessage(message, isResend)
    }).then(() => {
    }).catch(error => {
      hideDialog(IMManager.page)
      Toast.error('Failed to upload the picture', IMManager.page)
      loge(IMManager.TAG, 'send Image message failed:' + error)
    })
  }

  /**
   * 缓存查询未读消息任务
   *
   * 正常收到新消息，会先走 onUnreadMessagesCountUpdated 回调，再走 onMessage 回调
   * 只有在离线消息查询的时候才应该走查询逻辑
   *
   * 处理逻辑:1.收到 onUnreadMessagesCountUpdated 回调创建查询任务，并延迟50ms
   *         2.在收到 onMessage 回调时检查是否有当前会话的查询任务，如果有就取消任务
   */
  static createQueryJob(conv, limit) {
    if (isnull(conv)) {
      return
    }
    let queryJob = setTimeout(function () {
      IMManager.queryMessagesServer(conv, limit)
    }, IMManager.DELAY_QUERY_TIME)
    IMManager.queryJobs.set(conv.id, queryJob)
  }

  /**
   * 检查是否有需要取消的查询任务
   */
  static checkAndCancelQueryJob(conversation) {
    let job = this.queryJobs.get(conversation.id)
    if (job) {
      this.queryJobs.delete(conversation.id)
      clearTimeout(job)
    }
    log(IMManager.TAG, 'checkAndCancelQueryJob-- ' + job)
  }

  static clearQueryJob() {
    this.queryJobs.forEach(function (value, key, map) {
      clearTimeout(value)
    })
    this.queryJobs.clear()
  }

  static queryMessage(end, successCallback, failCallback, vueObj) {
    if (this.messageIterator) {
      this.messageIterator.next().then(function (result) {
        let roomMsgList = []
        result.value.forEach(function (item) {
          let roomMessage = IMHelper.parseMessage(item)
          if (roomMessage.from == global.getUserDisplay()) {
            roomMessage.sendStatus = MessageSendStatus.SUCCESS
          }
          roomMsgList.push(roomMessage)
        })
        successCallback && successCallback(roomMsgList, vueObj)
      }).catch(e => {
        failCallback && failCallback(e, vueObj)
      })
      // this.curConvBase.queryMessages({
      //   limit: 20,
      //   startTime: end,
      //   direction: MessageQueryDirection.OLD_TO_NEW
      // }).then(messages => {
      //   let roomMsgList = []
      //   messages.forEach(function (item) {
      //     let roomMessage = IMHelper.parseMessage(item);
      //     if (roomMessage.from == global.getUserDisplay())
      //       roomMessage.sendStatus = MessageSendStatus.SUCCESS
      //     roomMsgList.push(roomMessage)
      //   })
      //   successCallback && successCallback(roomMsgList, vueObj)
      // }).catch(e => {
      //   failCallback && failCallback(e, vueObj)
      // })
    } else {
      failCallback && failCallback('conversation is null', vueObj)
    }
  }

  static queryMessagesServer(conversation, limit) {
    log(IMManager.TAG, 'queryMessagesServer-- limit=' + limit)
    if (conversation) {
      conversation.queryMessages({
        limit: limit,
        direction: MessageQueryDirection.NEW_TO_OLD
      }).then(messages => {
        log(IMManager.TAG, 'queryMessagesServer 查询成功')
        if (isnull(messages)) {
          for (let i = 0; i < messages.length; i++) {
            IMManager.onReceiveMessage(messages[i], conversation)
          }
        }
      }).catch(e => {
        loge(IMManager.TAG, 'queryMessagesServer 查询失败')
      })

    }
  }

  static onReceiveMessage(message, conversation) {
    // 请按自己需求改写
    if (message == null || conversation == null) {
      return
    }
    console.log('ab=' + global.getUser().abTestFlag)
    if ((global.getUser().abTestFlag & 1073741824) > 0) {
      return
    }

    var parsedMsg = IMHelper.parseMessage(message)

    // 不接受老版IOS的消息且不接受老版客服消息
    if (parsedMsg.awayAccountId == 0) {
      return
    }
    //对方被自己拉黑
    if (BlockedUserUtils.hasBeenBlocked(parsedMsg.awayAccountId)) {
      return
    }
    let roomConversation = IMHelper.instanceRoomConversation(conversation, parsedMsg)
    parsedMsg.conversationId = roomConversation.conversationId
    parsedMsg.unread = roomConversation.unreadCount
    parsedMsg.convType = roomConversation.conversationType
    this.page.$EventBus.$emit(EventBusConstant.EVENT_REFRESH_LC_CHAT, roomConversation, parsedMsg)
    let roomMessage = IMHelper.instanceRoomMessage(parsedMsg)
    // 如果是当前正在聊天的对象，直接把未读数量赋值0
    if (this.curTargetDisplayAcc == parsedMsg.awayDisId) {
      conversation.read()
    } else {
      //显示消息弹窗
      this.page.$EventBus.$emit(global.LC_NEW_MSG, roomMessage)
    }

    //todo refreshMessageUi
    this.refreshMessageUi(roomMessage)
    // NotifyDelegate.showNotifyWithAvatar(
    //   displayId = parseMessage.awayDisId ?: "",
    //   accountId = parseMessage.awayAccountId ?: 0,
    //   nickName = parseMessage.awayNickname ?: "",
    //   avatar = parseMessage.awayAvatar,
    //   textContent = parseMessage.content ?: "",
    //   notifyType = PP_Constants.PushType.Message
    // )

    // conversation.read()
    vibrate()
  }

  static refreshMessageUi(roomMessage) {
    // 如果没有设置刷新会话的方法，则在收到消息时就不能刷新底部tab小红点
    if (this.refreshConversationListUI == null) {
      this.queryUnreadMsgCount()
    } else {
      this.refreshConversationListUI()
    }
    // 如果是正在聊天的人的消息，刷新消息列表
    if (roomMessage.awayDisId == this.curTargetDisplayAcc) {
      this.insertOrUpdateMsg && this.insertOrUpdateMsg(roomMessage)
    }
  }

  /**
   * 查询刷新未读消息数量
   */
  static queryUnreadMsgCount() {
    // AVIMHelper.doBackground{
    //   val conversations = TopDatabase.getInstance().getConversationDao()
    //     .queryAllUnReadConversation(YHManager.getDisId())
    //   var count = 0
    //   conversations?.forEach {
    //     count += it.unreadCount
    //   }
    //   withContext(Dispatchers.Main) {
    //     refreshUnReadMsgCountUI.invoke(count)
    //   }
    // }
  }

  /**
   * 刷新所有会话列表
   */
  refreshConversationListUI = null

  /**
   * 刷新未读消息数量UI
   */
  refreshUnReadMsgCountUI = null

  /**
   * 发送新消息回调
   */
  static insertOrUpdateMsg = null

  /**
   * 消息重发
   * @param message
   */
  static resendMsg(message) {
    switch (message.msgType) {
      case TextMessage.Type:
        this.sendMessage(message, true)
        break
      case AudioMessage.Type:
        this.sendAudioMessage(message.fileLocalPath, true)
        break
      case ImageMessage.Type:
        this.sendImageMessage(message.fileLocalPath, true)
        break
    }
  }
}



// WEBPACK FOOTER //
// ./src/im/IMManager.js